<template>
  <div>
    <spinner />

    <b-modal id="modalAuthenticate" ref="modalAuthenticate" hide-footer no-close-on-backdrop no-close-on-esc>
      <div slot="modal-title" v-translate>Authenticate Shopify</div>
      <div slot="modal-header-close"></div>
      <p v-translate>Please, write down the name of your store.</p>
      <form @submit.stop.prevent="redirectAuth">
        <b-input-group size="lg" append=".myshopify.com">
          <b-form-input v-model="store" ></b-form-input>
        </b-input-group>
         <div class="text-center mt-5">
          <b-button
            type="submit"
            variant="primary"
            size="lg"
            v-translate
          >Continue</b-button>
        </div>
      </form>
    </b-modal>

    <b-modal id="modalSelectShippingType" ref="modalSelectShippingType" hide-footer no-close-on-backdrop no-close-on-esc>
      <div slot="modal-title" v-translate>Shipments Import</div>
      <div slot="modal-header-close"></div>
      <p v-translate>Please, select the shipping type for the shippings you are about to import.</p>
      <form @submit.stop.prevent="doInitCreation">
        <b-form-radio-group stacked size="xl" v-model="shippingType" :options="shippingTypeOptions" />
        <div class="text-center mt-5">
          <b-button
            type="submit"
            variant="primary"
            size="lg"
            v-translate
          >Continue</b-button>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import Spinner from '@/components/Spinner'

export default {
  name: 'ShopifyRedirectPage',
  components: {
    Spinner
  },
  props: {
    type: {
      type: String,
      default: 'ongoing'
    }
  },
  data() {
    return {
      shippingType: 'shopify_24_horas_max',
      store: '',
      shippingTypeOptions: [
        {
          text: this.$gettext('Same Day'),
          value: 'shopify_24_horas_max'
        },
        {
          text: this.$gettext('Next Day'),
          value: 'next_day'
        }
      ]
    }
  },
  methods: {
    doInitCreation() {
      this.$refs.modalSelectShippingType.hide()
      this.initCreation()
    },
    async initCreation() {
      let listOfIds = this.$route.query['ids[]']
      const externalUserId = this.$route.query.shop
      listOfIds = Array.isArray(listOfIds) ? listOfIds : [listOfIds]
      const payload = {
        orders: listOfIds,
        shipping_type: this.shippingType,
        external_user_id: externalUserId
      }
      const result = await this.startShipments(payload)
      this.$router.push({
        name: 'integration-settings',
        query: {
          creation: true,
          shipmentsCount: listOfIds.length,
          success: result.success,
          message: result.message
        },
        params: {
          slug: 'shopify'
        }
      })
    },
    async startShipments(payload) {
      try {
        const url = this.$appConfig.api.baseUrl + 'users/' + this.$store.state.auth.uid + '/platforms/shopify/shipping'
        const shipping = await this.$http.post(url, payload)
        if (shipping.body.status && shipping.body.status === 'error') {
          return { success: 0, message: shipping.body.message }
        }
        return { success: 1, message: '' }
      } catch (error) {
        return { success: 0, message: error.body.message }
      }
    },
    async isNewVersionEnabled() {
      for (const app of this.$store.getters.profile.company.applications) {
        if (!app.webhook_url) continue
        const urlObj = new URL(app.webhook_url)
        const params = new URLSearchParams(urlObj.search)
        if (app.platform.slug === 'shopify-v2' && params.get('userId') === String(this.$store.state.auth.uid)) {
          return true
        }
      }
      return false
    },
    async redirectAuth() {
      const scope = 'scope=write_orders,write_customers,write_shipping,write_fulfillments,read_locations,read_assigned_fulfillment_orders,write_assigned_fulfillment_orders,write_merchant_managed_fulfillment_orders,read_merchant_managed_fulfillment_orders'
      const redirectUri = `${this.$appConfig.staticBaseUrl}profile/shopify/integration`
      const store = this.store.replace(/https?:\/{2}|\//gi, '')
      const query = `client_id=${this.$appConfig.integrations.shopify.appId}&${scope}&redirect_uri=${redirectUri}&state=${window.location.hostname}`
      const url = `https://${store}.myshopify.com/admin/oauth/authorize?${query}`
      window.location.href = url
    }
  },
  async mounted() {
    this.$store.state.dashboard.isLoading = true
    if (this.$route.params.action === 'create-shipping') {
      this.init()
        .then(async () => {
          if (!this.$store.state.auth.uid && !this.$store.getters.profile.id) {
            this.$router.push({ name: 'login', query: { redirect: this.$route.fullPath } })
          } else {
            return this.$router.push({
              name: 'shopify-v2-redirect',
              action: 'create-shipping',
              query: { ...this.$route.query }
            })
          }
        })
    } else if (this.$route.params.action === 'authenticate' && window.self === window.top) {
      this.$refs.modalAuthenticate.show()
      this.$store.state.dashboard.isLoading = false
    } else {
      console.log('pushing search')
      this.$router.push('/search')
    }
  }
}
</script>
